import { Component, Input } from '@angular/core';
import moment from 'moment';
import { DataTableColumn } from 'src/app/shared/components';
import { IcpAgentDashboardListDto, IcpMonthlySummaryDto, IcpWeeklySummary } from 'src/app/shared/dto';

@Component({
    selector: 'app-icp-card',
    templateUrl: './icp-card.component.html',
    styleUrls: ['../../../common-reporting-dashboard.scss'],
    standalone: false
})
export class IcpCardComponent {
    @Input() isShowChart: boolean;
    @Input() selectedOption: IcpAgentDashboardListDto | null;
    @Input()
    set combinedSummary(data: IcpMonthlySummaryDto) {
        if (data && this.selectedOption === null) {
            this.processIcpCombinedSummaryData(data);
        }
    };
    @Input()
    set exportSummary(data: IcpMonthlySummaryDto) {
        if (data && this.selectedOption && !this.selectedOption.email_only) {
            this.processSummaryData(data, 'total_company_count', 'total_contact_count');
        }
    };
    @Input()
    set emailOnlySummary(data: IcpMonthlySummaryDto) {
        if (data && this.selectedOption && this.selectedOption.email_only) {
            this.processSummaryData(data, 'total_company_count', 'total_contact_count');
        }
    };

    isWeeklyAgentsNotRun: boolean = false;
    isAllAgentsEmailOnly: boolean = false;
    isAllAgentsExportOnly: boolean = false;
    chartLabels: string[] = []
    chartData: Record<string, number[]> = {};

    tableData: IcpWeeklySummary[];
    combinedtableColumns: DataTableColumn[] = [
        {
            dataField: 'displayDate',
            caption: 'Date',
            cellTemplate: 'dateTemplate',
            width: '30%',
            cellClasses: 'border-b-0 pb-1 px-4',
            headerCellClasses: 'py-1',
            dateFormat: 'MM/dd/yy'
        },
        {
            dataField: 'total_company_count',
            caption: 'COMPANIES EXPORTED',
            cellTemplate: 'numberTemplate',
            width: '20%',
            allowSorting: true,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'py-1 text-center',

        },
        {
            dataField: 'total_contact_count',
            caption: 'CONTACTS EXPORTED',
            cellTemplate: 'numberTemplate',
            width: '20%',
            allowSorting: true,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'py-1 text-center',
        },
        {
            dataField: 'all_companies_count',
            caption: 'ALL COMPANIES',
            cellTemplate: 'numberTemplate',
            width: '20%',
            allowSorting: true,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'py-1 text-center',
        },
    ];
    tableColumns: DataTableColumn[] = [
        {
            dataField: 'displayDate',
            caption: 'Date',
            cellTemplate: 'dateTemplate',
            width: '40%',
            cellClasses: 'border-b-0 pb-1 px-4',
            headerCellClasses: 'py-1',
            dateFormat: 'MM/dd/yy'
        },
        {
            dataField: 'total_company_count',
            caption: 'Companies',
            cellTemplate: 'numberTemplate',
            width: '30%',
            allowSorting: true,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'py-1 text-center',
        },
        {
            dataField: 'total_contact_count',
            caption: 'Contacts',
            cellTemplate: 'numberTemplate',
            width: '30%',
            allowSorting: true,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'py-1 text-center',
        },
    ];

    private processIcpCombinedSummaryData(res: IcpMonthlySummaryDto) {
        this.isAllAgentsEmailOnly = res.is_email_only;
        this.isAllAgentsExportOnly = res.is_export_only;
        if (!res.is_email_only && !res.is_export_only) {
            this.isWeeklyAgentsNotRun = res.weekly_summary.reduce((sum, entry) => sum + entry.total_company_count + entry.total_contact_count + entry.all_companies_count, 0) === 0;
            this.tableData = res.weekly_summary.map((data: IcpWeeklySummary) => ({ ...data, "displayDate": moment(data.displayDate || data.week_end, 'YYYY-MM-DD').format('MM/DD/YYYY').toString(), total_company_count: data.total_company_count || 0, total_contact_count: data.total_contact_count || 0, all_companies_count: data.all_companies_count || 0 }))
            this.chartLabels = [];
            this.chartData = {};
            this.chartData = { ...this.chartData, "Companies Exported": [], "Contacts Exported": [], "All Companies": [] };
            res.weekly_summary.forEach((data: IcpWeeklySummary) => {
                const weekLabel = moment(data.displayDate || data.week_end, 'YYYY-MM-DD').format('MM/DD/YY').toString();
                this.chartLabels.push(weekLabel);
                this.chartData["Companies Exported"].push(data.total_company_count || 0);
                this.chartData["Contacts Exported"].push(data.total_contact_count || 0);
                this.chartData["All Companies"].push(data.all_companies_count || 0);
            })
        } else if(res.is_export_only) {
            this.processSummaryData(res, 'total_company_count', 'total_contact_count');
        } else if(res.is_email_only) {
            this.processSummaryData(res, 'all_companies_count', 'all_contacts_count');
        }
    }

    private processSummaryData(res: IcpMonthlySummaryDto, companyKey: string, contactKey: string): void {
        this.isWeeklyAgentsNotRun = res.weekly_summary.reduce((sum, entry) => sum + entry[companyKey] + entry[contactKey], 0) === 0;
        this.tableData = res.weekly_summary.map((data: IcpWeeklySummary) => ({ ...data, "displayDate": moment(data.displayDate || data.week_end, 'YYYY-MM-DD').format('MM/DD/YYYY').toString(), total_company_count: data[companyKey] || 0, total_contact_count: data[contactKey] || 0 }))
        this.chartLabels = [];
        this.chartData = {};
        this.chartData = { ...this.chartData, "Companies": [], "Contacts": [] };
        res.weekly_summary.forEach((data: IcpWeeklySummary) => {
            const weekLabel = moment(data.displayDate || data.week_end, 'YYYY-MM-DD').format('MM/DD/YY').toString();
            this.chartLabels.push(weekLabel);
            this.chartData["Companies"].push(data[companyKey]);
            this.chartData["Contacts"].push(data[contactKey]);
        })
    }

}
